import { useEffect } from 'react';
import { DashboardLayout } from './components/Layout';
import { SettingsPage } from './pages/SettingsPage';
import { LegalConsentShield } from './components/LegalConsentShield';

const DASHBOARD_THEME_STORAGE_KEY = 'reach_dashboard_theme';
const LOCKED_DASHBOARD_THEME = 'ocean';

function App() {
  const shopDomain = new URLSearchParams(window.location.search).get("shop") || "localhost";

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', LOCKED_DASHBOARD_THEME);
    localStorage.setItem(DASHBOARD_THEME_STORAGE_KEY, LOCKED_DASHBOARD_THEME);
  }, []);

  return (
    <>
      <LegalConsentShield shopDomain={shopDomain} />
      <DashboardLayout>
        <SettingsPage />

      {/* <div
        style={{
          position: 'fixed',
          right: 16,
          bottom: 16,
          zIndex: 9999,
          background: 'var(--surface-1)',
          border: '1px solid var(--border-default)',
          borderRadius: 12,
          padding: '8px 10px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <label htmlFor="dashboard-theme-select" style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600 }}>
          Theme
        </label>
        <select
          id="dashboard-theme-select"
          value={LOCKED_DASHBOARD_THEME}
          onChange={() => {}}
          style={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid var(--border-default)',
            padding: '4px 8px',
            background: 'var(--surface-1)',
            color: 'var(--text-primary)',
          }}
        >
          <option value="reach-classic">Classic</option>
          <option value="ocean">Ocean</option>
          <option value="forest">Forest</option>
          <option value="sunset">Sunset</option>
          <option value="amethyst">Amethyst</option>
          <option value="mono">Mono</option>
          <option value="rose">Rose</option>
        </select>
      </div> */}
      </DashboardLayout>
    </>
  );
}

export default App;
